import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Exemption from "../Exemption";
import axios from "axios";

import ModalHeader from "../../../common/components/ModalHeader";

const ExemptionModal = ({
  exemptionOptions,
  onHide,
  show,
  testGroup,
  testGroupImmunizationsExemptionUrl,
}) => {

  const [exemption, setExemption] = useState({});
  const [error, setError] = useState(null);
  const [loadingSave, setLoadingSave] = useState(false);

  const handleSaveExemption = async () => {
    if (validateMissingFields()) return;

    setLoadingSave(true);
    try {
      const formData = new FormData();
      formData.append('exemptions[authorized_by_name]', exemption.authorizedByName || '');
      formData.append('exemptions[category]', exemption.category || '');
      formData.append('exemptions[conditions]', exemption.conditions || []);
      formData.append('exemptions[expires_at]', exemption.expiresAt || '');
      formData.append('exemptions[exemption_type]', exemption.exemptionType || '');

      if (exemption.exemptionDocument) {
        formData.append('exemptions[exemption_document]', exemption.exemptionDocument);
      }

      await axios.post(testGroupImmunizationsExemptionUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      window.location.reload();
    } catch (e) {
      setError('Failed to save exemption. Please try again.');
    } finally {
      setLoadingSave(false);
    }
  };

  const validateMissingFields = () => {
    if (Object.keys(exemption).length > 0) {
      if (
        !exemption.exemptionType ||
        !exemption.conditions?.length > 0 ||
        (exemption.exemptionType === 'temporary' && !exemption.expiresAt)
      ) {
        setError('Please fill the missing required values.');
        return true;
      }
    }
    return false;
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <ModalHeader closeButton onHide={onHide}>
        <Modal.Title>Add exemption</Modal.Title>
      </ModalHeader>
      <Modal.Body>
        <Exemption
          exemption={exemption}
          dispatch={({ type, value }) => setExemption(value)}
          conditionOptions={exemptionOptions}
          allowNonMedicalExemptions={testGroup.allow_non_medical_exemptions}
        />
        {error && <div className="text-warning mt-3">{error}</div>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSaveExemption} disabled={loadingSave}>
          {loadingSave ? 'Saving...' : 'Save exemption'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ExemptionModal;
